import {
  motion,
  useAnimation,
  useMotionValue,
  useSpring,
  useTransform,
  useVelocity,
} from "framer-motion";
import { throttle } from "lodash";
import { useCallback, useEffect, useMemo } from "react";
import { useMotion, useWindowSize } from "react-use";
import styled from "styled-components";
import { videoWallConfig } from "../../mock/video-wall";
import { easings, fill } from "../../styles/utils";

interface VideoWallBoardDesktopProps {
  watchMouseMove?: boolean;
  onStopAnimating?: (v: boolean) => any;
}

const MotionContainer = styled(motion.div)`
  ${fill()}
  background-color: red;
`;

const MotionBoard = styled(motion.div)`
  position: absolute;
  height: ${videoWallConfig.heightFactor * 100}vh;
  width: ${videoWallConfig.widthFactor * 100}vw;
  left: ${((videoWallConfig.widthFactor - 1) * -100) / 2}vw;
  top: ${((videoWallConfig.heightFactor - 1) * -100) / 2}vh;
  background-color: ${({ theme }) => theme.colors.blueDark};
`;

export const VideoWallBoardDesktop: React.FC<VideoWallBoardDesktopProps> = ({
  children,
  watchMouseMove = true,
  onStopAnimating,
}) => {
  const cursorX = useMotionValue(0);
  const cursorY = useMotionValue(0);

  const { width, height } = useWindowSize();

  const physics = {
    damping: 30,
    mass: 2,
    stiffness: 100,
  };

  const xSpring = useSpring(cursorX, physics);
  const ySpring = useSpring(cursorY, physics);
  const x = useTransform(xSpring, [0, width], ["25%", "-25%"]);
  const y = useTransform(ySpring, [0, height], ["25%", "-25%"]);
  const xVelocity = useVelocity(xSpring);

  const handleMouseMove: React.MouseEventHandler<HTMLDivElement> = (e) => {
    cursorX.set(e.clientX);
    cursorY.set(e.clientY);
  };

  useEffect(() => {
    const unSub = xVelocity.onChange((v) => {
      if (onStopAnimating) {
        if (v === 0) {
          onStopAnimating(true);
        } else {
          onStopAnimating(false);
        }
      }
    });

    return () => {
      unSub();
    };
  }, [xVelocity, onStopAnimating]);

  return (
    <MotionContainer onMouseMove={watchMouseMove ? handleMouseMove : () => {}}>
      <MotionBoard style={{ x, y }}>{children}</MotionBoard>
    </MotionContainer>
  );
};
